import { LitElement, html, css, unsafeCSS, nothing } from 'lit';
import { styleMap } from 'lit/directives/style-map.js';
import styles from './img-product.scss?inline';

export default class SotbitImgProduct extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        src: { type: String },
        alt: { type: String },
        img: { type: String },
        srcset: { type: String },
        lightbox: { type: Boolean },
        objectFit: { type: String, attribute: 'object-fit' },
        loading: { type: String },
        width: { type: String },
        height: { type: String },
    };

    constructor() {
        super();

        this.src = '';
        this.img = null;
        this.alt = null;
        this.lightbox = false;
        this.loading = null;
        this.width = null;
        this.height = null;
    }

    render() {
        const objectFitStyle = { objectFit: this.objectFit };

        return html`
            <div class="img-wrapper" part="img-wrapper">
                ${this.lightbox
                    ? html` <slot name="lightbox-icon">
                          <sotbit-icon
                              part="lightbox-icon"
                              size="l"
                              variant="simple"
                              class="icon"
                              icon="zoom-in"
                          ></sotbit-icon>
                      </slot>`
                    : ''}
                <slot name="img">
                    <img
                        style=${styleMap(objectFitStyle)}
                        srcset="${this.srcset || nothing}"
                        class="img"
                        part="img"
                        src="${this.src || nothing}"
                        alt="${this.alt || nothing}"
                        loading="${this.loading || nothing}"
                        width="${this.width || nothing}"
                        height="${this.height || nothing}"
                    />
                </slot>
            </div>
        `;
    }
}
